import { isNull } from "lodash";
import React, { useCallback, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  Map as GoogleMap,
  useMap,
} from "@vis.gl/react-google-maps";

// Imported components
import Marker from "./Marker.js";

const mapStyle = {
  width: "100%",
  height: "100%",
};

const mapOptions = {
  clickableIcons: false,
  fullscreenControl: false,
  mapTypeControl: false,
  maxZoom: 22,
  minZoom: 0,
  streetViewControl: false,
  styles: [
    {
      featureType: "poi",
      stylers: [{ visibility: "off" }],
    },
    {
      featureType: "landscape",
      elementType: "labels",
      stylers: [{ visibility: "off" }],
    },
    {
      featureType: "transit",
      stylers: [{ visibility: "off" }],
    },
  ],
  zoomControl: false,
};

const Map = ({ markers, selectedStation }) => {
  const map = useMap();
  const navigate = useNavigate();

  const [mapCenter, setMapCenter] = useState(null);
  const [mapZoom, setMapZoom] = useState(null);

  useEffect(() => {
    if (!isNull(selectedStation)) {
      let data = markers.find((m) => m.id === selectedStation);
      setMapCenter({
        lat: Number(data.lat),
        lng: Number(data.lon),
      });
      setMapZoom(12);
    } else if (map && markers) {
      setMapCenter(null);
      setMapZoom(null);
      let bounds = new window.google.maps.LatLngBounds();
      Object.values(markers)
        .map((marker) => ({ lat: Number(marker.lat), lng: Number(marker.lon) }))
        .forEach((marker) => bounds.extend(marker));
      map.fitBounds(bounds, 20);
    }
  }, [map, selectedStation, markers]);

  const handleCameraChange = useCallback((e) => {
    setMapCenter(e.detail.center);
    setMapZoom(e.detail.zoom);
  });

  return (
    <>
      <GoogleMap
        {...mapOptions}
        center={!isNull(mapCenter) ? mapCenter : null}
        className={"dashboard-map"}
        disableDefaultUI={true}
        gestureHandling={"greedy"}
        mapId={"704f78d978e3652a"}
        onCameraChanged={handleCameraChange}
        onClick={() => navigate("/console-view")}
        reuseMaps={false}
        style={mapStyle}
        zoom={!isNull(mapZoom) ? mapZoom : null}
      >
        {markers &&
          Object.values(markers).map((marker) => {
            return (
              <Marker
                data={marker}
                key={`marker-${marker.id}`}
                position={{
                  lat: Number(marker.lat),
                  lng: Number(marker.lon),
                }}
              />
            );
          })}
      </GoogleMap>
    </>
  );
};

export default Map;
